/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext, useMemo, useRef } from "react";
import { v4 as uuid } from "uuid";
import { Shard } from "../../core/shard";
export const scopedList = new Map();
const Context = createContext({});
export const useScope = () => useContext(Context);
const Scope = ({ children, shards }) => {
    const tempID = useRef();
    const id = useMemo(() => {
        if (tempID.current)
            return tempID.current;
        const scopedId = uuid();
        tempID.current = scopedId;
        if (Array.isArray(shards)) {
            const scopedShards = shards.map((i) => {
                const newShard = new Shard(i.getInitialValue(), i.getId());
                newShard.addScope(scopedId);
                return newShard;
            });
            scopedList.set(scopedId, scopedShards);
        }
        else {
            const keys = Object.keys(shards);
            const scopedShards = keys.map((i) => {
                var _a;
                if (((_a = shards[i]) === null || _a === void 0 ? void 0 : _a.getKey) !== undefined) {
                    return shards[i];
                }
                const currentShard = shards[i];
                const newShard = new Shard(currentShard.getInitialValue(), currentShard.getId());
                newShard.addScope(scopedId);
                return newShard;
            });
            scopedList.set(scopedId, scopedShards);
        }
        return scopedId;
    }, []);
    return (React.createElement(Context.Provider, { value: { scopeId: id } }, children));
};
export { Scope };
//# sourceMappingURL=index.js.map